document.addEventListener('DOMContentLoaded', () => {
  const description = document.querySelector('.product__description');
  if (!description) return;

  // Only collapse if the description is actually tall enough to need it.
  if (description.scrollHeight <= 220) return;

  description.classList.add('lacha-description--collapsible');

  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'lacha-description-toggle';
  toggle.textContent = 'See more';
  description.insertAdjacentElement('afterend', toggle);

  toggle.addEventListener('click', () => {
    const expanded = description.classList.toggle('lacha-description--expanded');
    toggle.textContent = expanded ? 'See less' : 'See more';
  });
});
